import { REFUND_ACTION_TYPES } from "../actions/refund.action";

const initialState = {
  refundData: {
    isDataFetched: false,
    isLoading: false,
    isGstLossCase: false,
    opportunityId: null,
    isStatusPending: false,
    entries: [],
    refundedAmount: null,
    approvedAmount: null,
    lastCancellationDate: null,
    refundCreatedAt: null,
  },
  refundTabularData: {
    data: {},
    currentStatus: null,
    isDataLoading: false,
  },
};

const refundReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFUND_ACTION_TYPES.REFUND_OPPORTUNITY_DATA: {
      const {
        opportunityId,
        isStatusPending = false,
        isGstLossCase = false,
        entries = [],
        refundedAmount,
        approvedAmount,
        lastCancellationDate,
        refundCreatedAt,
        refundApproverAuthorityId,
      } = action.payload;

      return {
        ...state,
        refundData: {
          ...state.refundData,
          opportunityId,
          isStatusPending,
          isGstLossCase,
          entries,
          refundedAmount,
          approvedAmount,
          lastCancellationDate,
          refundCreatedAt,
          refundApproverAuthorityId,
          isDataFetched: true,
        },
      };
    }
    case REFUND_ACTION_TYPES.CLEAR_REFUND_DATA: {
      return {
        ...state,
        refundData: {
          ...state.refundData,
          opportunityId: null,
          isStatusPending: false,
          isGstLossCase: false,
          entries: [],
          refundedAmount: null,
          approvedAmount: null,
          lastCancellationDate: null,
          refundCreatedAt: null,
          refundApproverAuthorityId: null,
          isDataFetched: false,
        },
      };
    }
    case REFUND_ACTION_TYPES.PAGE_LOADING:
      return {
        ...state,
        refundData: {
          ...state.refundData,
          isLoading: true,
        },
      };
    case REFUND_ACTION_TYPES.PAGE_LOADED:
      return {
        ...state,
        refundData: {
          ...state.refundData,
          isLoading: false,
          isDataFetched: true,
        },
      };
    case REFUND_ACTION_TYPES.GET_REFUND_TABULAR_DATA: {
      const { currentStatus, data } = action.payload;
      return {
        ...state,
        refundTabularData: {
          ...state.refundTabularData,
          data: {
            ...(state.refundTabularData && state.refundTabularData.data
              ? state.refundTabularData.data
              : {}),
            [currentStatus]: {
              list: [
                ...(state.refundTabularData?.data?.[currentStatus]?.list || []),
                ...(data?.approvalTabViewList || []),
              ],
              lastId: data?.lastId || null,
              totalCount:
                data?.totalCount ||
                state.refundTabularData?.data?.[currentStatus]?.totalCount ||
                0,
            },
          },
          currentStatus,
        },
      };
    }
    case REFUND_ACTION_TYPES.SET_REFUND_STATUS: {
      const { currentStatus } = action.payload;
      return {
        ...state,
        refundTabularData: { ...state.refundTabularData, currentStatus },
      };
    }
    case REFUND_ACTION_TYPES.CLEAR_TABULAR_DATA: {
      return {
        ...state,
        refundTabularData: {
          data: {},
          currentStatus: null,
        },
      };
    }
    case REFUND_ACTION_TYPES.SET_TABULAR_PAGE_LOADING: {
      return {
        ...state,
        refundTabularData: {
          ...state.refundTabularData,
          isDataLoading: action.payload,
        },
      };
    }
  }
};

export default refundReducer;
